export const markdownData = `
# Markdown演示

这里是**markdown**的演示内容，下方将显示目前markdown对一些常见内容的支持情况，如文字效果、列表、表格、代码等。

## 二级标题
### 三级标题
#### 四级标题
##### 五级标题

## 文本

**加粗**

*斜体*

~~删除线~~


## 水平线
___

我的上下是水平线

---

## 列表

下方是个无序列表
+ 西安
+ 成都
+ 重庆
+ 苏州


下面是个有序列表
1. 早饭
2. 中饭
3. 晚饭

## 图片

下方是一张图片

![](http://p.qpic.cn/qidian_pic/0/20200226d9e3ac7378c87009739ed91984d8d2e9/0)

## 链接
这里是[百度](https://www.baidu.com)

# 引用
> 这里是**引用**的文本.


## 表格

基本表格使用:

| 列1标题 | 列2标题 | 列3标题 |
| ------ | ------ | ------ |
| 内容1 | 内容2 | 内容3 |
| 内容4 | 内容5 | 内容6 |

## 代码

**行内代码**：这里是一个常用的API：\`document.getElementById\`。

**js**
\`\`\`js
const xyz = 99999999999999999999999999999999999999999999999999999999999999999999999999999999999999;';

const foo = function (bar) {

return bar++;

};
console.log(foo(5));
\`\`\`

**c**
\`\`\`c
int a = 0;
function main(){
	printf("%d", a);
}
\`\`\`

**java**
\`\`\`java
class A{
	private int a;
	private final int b;
	public int get(){
		 return a;
	}
} 
\`\`\`

`;
